import React from "react";
import { Modal, Button } from "react-bootstrap";
import { apiRequest } from "../../utils/utils";
import { decrypt } from "../../actions/common";
import { getCookie } from "../crm/customer/Utility";

const MoveToDemo = (props) => {
  const user_uuid = getCookie("muvi_useruuid");
  const { data } = props;
  console.log(props, 4534543543534);

  var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
  var localdata = has_local_data
    ? decrypt(localStorage.getItem("encdata"), 0)
    : "";

  const moveToDemoSubmit = async () => {
    const requestData = {
      app_token: data.customer_id,
      is_demo: data.is_demo,
      is_live: false,
      product_key: data.product_key,
      store_key: data.store_key,
      user_uuid: user_uuid ? user_uuid : localdata.user_uuid,
    };
    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/muvi6/manage-demo-account`,
      "POST",
      requestData
    );

    if (responseData.code === 200) {
      props.syncFilterWithAggrid();
      props.close();
    }
  };
  return (
    <Modal show={props.show} onHide={props.close}>
      <Modal.Header>
        <Modal.Title>{data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>{data.confirmText}</h5>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            type="button"
            variant="dark"
            className="btn-dark-btn"
            onClick={props.close}
          >
            Close
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={() => moveToDemoSubmit()}
          >
            Submit
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default MoveToDemo;



// WEBPACK FOOTER //
// ./src/components/childcomponents/MoveToDemo.js